var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "900" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-column")))]),
      _c(
        "app-detail-settings-edit-content",
        {
          attrs: {
            "selected-language": _vm.selectedLanguage,
            value: _vm.value,
            "model-name": "SaleRow",
          },
        },
        [
          _c(
            "w-row",
            { attrs: { slot: "before" }, slot: "before" },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-custom-language-select", {
                    attrs: {
                      value: _vm.selectedLanguage,
                      fancy: "",
                      label: _vm.$ct("common.lang"),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.setSelectedLanguage($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { slot: "before" }, slot: "before" },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-select", {
                    attrs: {
                      items: _vm.lineNumberItems,
                      label: _vm.$ct("rule-number"),
                      fancy: "",
                    },
                    model: {
                      value: _vm.value.LineNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "LineNumber", $$v)
                      },
                      expression: "value.LineNumber",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { slot: "before-filters" }, slot: "before-filters" },
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-switch", {
                    attrs: { label: _vm.$ct("show-as-barcode") },
                    model: {
                      value: _vm.value.PrintAsBarcodeSettings.Enabled,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value.PrintAsBarcodeSettings,
                          "Enabled",
                          $$v
                        )
                      },
                      expression: "value.PrintAsBarcodeSettings.Enabled",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-transition-slide-height",
            { attrs: { slot: "before-filters" }, slot: "before-filters" },
            [
              _vm.value.PrintAsBarcodeSettings.Enabled
                ? _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.barcodeTypeItems,
                              fancy: "",
                              label: _vm.$ct("barcode-type"),
                            },
                            model: {
                              value:
                                _vm.value.PrintAsBarcodeSettings.BarCodeType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.PrintAsBarcodeSettings,
                                  "BarCodeType",
                                  $$v
                                )
                              },
                              expression:
                                "value.PrintAsBarcodeSettings.BarCodeType",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              decimals: 2,
                              min: 0,
                              fancy: "",
                              label: _vm.$ct("barcode-height"),
                            },
                            model: {
                              value: _vm.value.PrintAsBarcodeSettings.Height,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.value.PrintAsBarcodeSettings,
                                  "Height",
                                  $$v
                                )
                              },
                              expression: "value.PrintAsBarcodeSettings.Height",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("w-switch", {
            style: {
              flexShrink: 0,
              flexGrow: 0,
              width: "auto",
              paddingLeft: "5px",
            },
            attrs: {
              slot: "after",
              reverse: "",
              value: _vm.value.HeaderField != null,
              label: _vm.$ct("has-column-header"),
            },
            on: {
              input: function ($event) {
                return _vm.onToggleHasHeader($event)
              },
            },
            slot: "after",
          }),
        ],
        1
      ),
      _c(
        "transition",
        {
          on: {
            "before-leave": _vm.onDetailSettingsBeforeLeave,
            leave: _vm.onDetailSettingsLeave,
            enter: _vm.onDetailSettingsEnter,
            "after-enter": _vm.onDetailSettingsAfterEnter,
          },
        },
        [
          _vm.value.HeaderField
            ? _c("app-detail-settings-edit-content", {
                staticClass: "slide-height-transition",
                attrs: {
                  "selected-language": _vm.selectedLanguage,
                  value: _vm.value.HeaderField,
                  "is-header": "",
                  "model-name": "Sale",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }